import { render, staticRenderFns } from "./CheckGovernment.vue?vue&type=template&id=664e07be&scoped=true"
import script from "./CheckGovernment.vue?vue&type=script&lang=js"
export * from "./CheckGovernment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664e07be",
  null
  
)

export default component.exports